exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[class*=\" icon-\"][data-v-09cb2479]:before,[class^=icon-][data-v-09cb2479]:before{margin:0!important}", ""]);

// exports
